const test = [
  {
    flowType: 'general',
    pages: ['pageA', 'pageB', 'pageC'],
  },
];

const phoenix = [
  {
    flowType: 'general',
    pages: ['gender', 'current-height', 'current-weight', 'goal-weight', 'daily-activity', 'weekly-weight-goal'],
  },
  {
    flowType: 'general',
    pages: ['fitness-intro', 'workout-intensity', 'fitness-goal', 'preferred-workout-length', 'preferred-workout-days', 'equipment-preferences', 'confirm-your-formula'],
  },
  {
    flowType: 'confirmFormula',
    pages: ['current-weight', 'goal-weight', 'weekly-weight-goal', 'confirm-your-formula'],
  },
];

/*
const wolf = [
  {
    flowType: 'general',
    pages: ['birthday', 'gender', 'current-height', 'current-weight', 'workout-type', 'multi-fitness-goal', 'muscle-groups', 'performance-areas', 'goal-weight', 'weekly-weight-loss-goal', 'preferred-workout-days', 'daily-activity', 'preferred-workout-length', 'equipment-preferences'],
    icons: ['BIRTHDAY_CAKE', 'GENDER_SYMBOLS', 'HEIGHT', 'WEIGHT_SCALE', 'RUNNER', 'GOALS', 'CALENDAR_WEEK', 'STEPS', 'TIMER', 'BIKE'],
    iconMapping: {
      'birthday': 'BIRTHDAY_CAKE',
      'gender': 'GENDER_SYMBOLS',
      'current-height': 'HEIGHT',
      'current-weight': 'WEIGHT_SCALE',
      'workout-type': 'RUNNER',
      'multi-fitness-goal': 'GOALS',
      'muscle-groups': 'GOALS',
      'performance-areas': 'GOALS',
      'goal-weight': 'GOALS',
      'weekly-weight-loss-goal': 'GOALS',
      'preferred-workout-days': 'CALENDAR_WEEK',
      'daily-activity': 'STEPS',
      'preferred-workout-length': 'TIMER',
      'equipment-preferences': 'BIKE',
    }
  }
];
*/

const wolf = [
  {
    flowType: 'general',
    pages: ['wolf-user-profile', 'gender', 'current-height', 'current-weight', 'optional-shipping'],
    icons: ['BIRTHDAY_CAKE', 'GENDER_SYMBOLS', 'HEIGHT', 'WEIGHT_SCALE', 'GOALS'],
    iconMapping: {
      'wolf-user-profile': 'BIRTHDAY_CAKE',
      'gender': 'GENDER_SYMBOLS',
      'current-height': 'HEIGHT',
      'current-weight': 'WEIGHT_SCALE',
      'optional-shipping': 'GOALS'
    }
  }
];

const appInfo = { test, phoenix, wolf };

const getNavData = (appName, flowType, page) => {
  const flows = appInfo[appName || 'phoenix'];
  let navData = {};
  for (let i = 0; i < flows.length; i++) {
    const data = flows[i];
    if (data.flowType === flowType && data.pages.indexOf(page) > -1) {
      if (data.icons) {
        navData = { icons: data.icons, iconMapping: data.iconMapping, currentIndex: data.pages.indexOf(page) };
      } else {
        navData = { totalPages: data.pages.length, currentIndex: data.pages.indexOf(page) };
      }
      break;
    }
  };

  return navData;
};

export default getNavData;
